import axiosInstance from "app/axiosInstance";
import { ObjectTypesRequestDto } from "../entities/dtos/object-types-request.dto";

export const getObjectTypes = async (payload: ObjectTypesRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get(
      `/accounts/${accountId}/objecttypes`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
